'use client';
import { Badge as SharedBadge } from '@launchstore/shared-puck';
import type { BadgeProps } from '@launchstore/shared-puck';
export const Badge: any = SharedBadge;
export type { BadgeProps };
export default Badge;
